import React, { useState, useEffect, memo } from 'react';
import json from '../../Auditoria/index.json';
import { Objeto } from '../../../../Services/Models';
import { L10n, loadCldr, setCulture, setCurrencyCode, getValue } from '@syncfusion/ej2-base';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs } from '@syncfusion/ej2-react-grids'
import moment from 'moment';
import {
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  GridComponent,
  Page,
  Inject,
  Filter,
  Group,
  ExcelExport,
  PdfExport,
  Toolbar,
  ToolbarItems,
  Grid,
  FilterSettingsModel,
  Column,
  Sort,
  Resize
} from '@syncfusion/ej2-react-grids';
import './style.css'
import { ObjectInfo } from '@syncfusion/ej2/pdf-export';

L10n.load(json)

function App({ vendasDistratadas }: any) {
  const [getProjectData, setProjectData] = useState();
  const [getLoading, setLoading] = useState<boolean>(true)
  const [getData, setData] = useState<Array<Objeto.VendaDistratadasData>>([]);
  let preTotalValue: number = 0;
  let preData: Array<Objeto.VendaDistratadasData> = [];
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs | any) => {
    args.cell.cellHeight = 10;
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(2).textAlign = "Right";
  }
  const filterOptions: FilterSettingsModel = {
    ignoreAccent: true,
    immediateModeDelay: 200,
    mode: "Immediate",
    type: 'Excel'
  }
  const queryCellInfoEvent = (args: any) => {
    if ((args.column as Column).field === 'STATUS_DISTRATO' && args.data && args.cell) {
      if (getValue('STATUS_DISTRATO', args.data) === 'Aprovado') {
        args.cell.classList.add('aprovado');
      }
      else {
        args.cell.classList.add('reprovado');
      }
    }
  }
  let grid: Grid | null;
  const toolbarOptions: ToolbarItems[] = ['PdfExport', 'CsvExport']
  const toolbarClick = (args: any) => {
    console.log('pre-grid')
    if (grid) {
      console.log(args.item.id)
      if (args.item.id === 'grid_pdfexport') {
        grid.pdfExport({
          fileName: `Vendas De Cessão ${moment(new Date(), true).format("YYYY-MM-DD")}.pdf`,
          pageOrientation: "Landscape",
          header: {
            fromTop: 0,
            height: 130,
            contents: [
              // {
              //   type: 'Text',
              //   value: `${getItemPickerCentroDeCusto?.descricao}`,
              //   position: { x: 390, y: 50 },
              //   style: { textBrushColor: "#000000", fontSize: 20, hAlign: "Right" },
              // },
              // {
              //   position: { x: 0, y: 45 },
              //   size: { height: 40, width: 80 },
              //   src: image,
              //   type: 'Image',
              // },
              {
                type: 'Text',
                value: `${moment(new Date(), true).format("DD/MM/YYYY HH:mm:ss")}`,
                position: { x: 880, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 13 },
              },
            ]
          },
          footer: {
            contents: [
              {
                type: 'Text',
                value: `Powered by DigitalDEV`,
                position: { x: 0, y: 55 },
                style: { textBrushColor: "#000000", fontSize: 10 },
              },
              {
                format: 'Página {$current} de {$total}',
                pageNumberType: "Numeric",
                position: { x: 910, y: 50 },
                style: {
                  fontSize: 13,
                  hAlign: "Right",
                  textBrushColor: '#000000',
                },
                type: 'PageNumber',
              }
            ],
            fromBottom: 0,
            height: 100,
          },
          theme: {
            header: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            },
            record: {
              bold: false,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7)
            },
            caption: {
              bold: true,
              fontColor: "#000000",
              fontSize: 8,
              // font: new PdfTrueTypeFont(adventProFont, 7, PdfFontStyle.Bold)
            }
          },
          allowHorizontalOverflow: false,

        });
      }
      if (args.item.id === 'grid_excelexport') {
        grid.excelExport({
          dataSource: getData
        })
      }
      if (args.item.id === 'grid_csvexport') {
        grid.getColumnByField('Valor_Prc').format = "N2"
        grid.getColumnByField('VlrPago_Des').format = "N2"
        grid.getColumnByField('VlrAPagar_Des').format = "N2"
        grid.getColumnByField('ValorVenda').format = "N2"
        grid.csvExport({
          dataSource: getData
        })
      }
    }
  }

  useEffect(() => {
    async function componentDidMount() {
      if (vendasDistratadas) {
        await vendasDistratadas.map((objeto: Objeto.VendaDistratadasData, index: number) => {
          objeto.total_distrato = Number(objeto.VlrPago_Des) + Number(objeto.VlrAPagar_Des)
          objeto.percent_dev = `${Math.round((objeto.total_distrato / objeto.VlrRecebido) * 10000) / 100}%`
          objeto.nome_pes = `${objeto.CodCliente} - ${objeto.nome_pes}`
          objeto.NM_Empresa = `${objeto.CodEmpresa} - ${objeto.NM_Empresa}`
          objeto.NM_Obra = `${objeto.CodObra} - ${objeto.NM_Obra}`
          objeto.DataCad = objeto.DataCad ? moment(objeto.DataCad, "YYYY-MM-DD").format("DD/MM/YYYY") : objeto.DataCad
          objeto.DataVenda = objeto.DataVenda ? moment(objeto.DataVenda, "YYYY-MM-DD").format("DD/MM/YYYY") : objeto.DataVenda
          objeto.DataCancel = objeto.DataCancel ? moment(objeto.DataCancel, "YYYY-MM-DD").format("DD/MM/YYYY") : objeto.DataCancel
          preData.push(objeto
          )
        })
        await setData(preData)
        await setLoading(false)
      }
    }
    componentDidMount();
  }, [vendasDistratadas])

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <GridComponent
          dataSource={getData}
          id='grid'
          allowSorting={true}
          allowMultiSorting={true}
          ref={g => grid = g}
          allowPaging={true}
          allowFiltering={true}
          pageSettings={{ pageSizes: [10, 15, 20, 25, 30], pageSize: 15 }}
          filterSettings={filterOptions}
          toolbarClick={toolbarClick}
          toolbar={toolbarOptions}
          width="100%"
          pdfQueryCellInfo={pdfQueryCellInfo}
          pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
          allowPdfExport={true}
          allowExcelExport={true}
          allowResizing={true}
          actionBegin={
            (args: any) => {
              if (args.requestType === "filterchoicerequest" || args.requestType === 'filtersearchbegin') {
                args.filterChoiceCount = 1000000;
              }
            }
          }
          style={{ opacity: getLoading === true ? "0.5" : "1", pointerEvents: getLoading === true ? "none" : "auto" }}>
          <ColumnsDirective>
            <ColumnDirective field='NM_Empresa' headerText='Empresa' width='200px' />
            <ColumnDirective field='NM_Obra' headerText='Obra' width='200px' />
            <ColumnDirective field='DataCad' headerText='DataCad' width='200px' />
            <ColumnDirective field='DataVenda' headerText='DataVenda' width='170px' />
            <ColumnDirective field='Venda' headerText='Venda' width='160px' />
            <ColumnDirective field='Identificador_unid' headerText='Unidade' width='200px' />
            <ColumnDirective field='ValorVenda' format="C2" headerText='ValorVenda' width='130px' />
            <ColumnDirective field='DataCessao' headerText='DataCessao' width='130px' />
            <ColumnDirective field='DataCancel' headerText='DataCancel' width='180px' />
            <ColumnDirective field='nome_pes' headerText='Cliente' width='200px' />
            <ColumnDirective field='idContrato' headerText='idContrato' width='130px' />
            <ColumnDirective field='ContratoFinan' headerText='ContratoFinan' width='200px' />
            <ColumnDirective field='VlrRecebido' type='number' format="C2" headerText='Recebido' width='200px' />
            <ColumnDirective field='Valor_Prc' format="C2" headerText='A Receber' width='200px' />
            <ColumnDirective field='total_distrato' type='number' format="C2" headerText='Total Distrato' width='200px' />
            <ColumnDirective field='percent_dev' type='string' headerText='% Devolução' width='200px' />
            <ColumnDirective field='VlrPago_Des' format="C2" headerText='Pago' width='200px' />
            <ColumnDirective field='VlrAPagar_Des' type='number' format="C2" headerText='A Pagar' width='200px' />
          </ColumnsDirective>
          <AggregatesDirective>
            <AggregateDirective>
              <AggregateColumnsDirective>
                <AggregateColumnDirective field="VlrAPagar_Des" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="VlrPago_Des" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="Valor_Prc" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="ValorVenda" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="total_distrato" type="Sum" format="C2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
                <AggregateColumnDirective field="M2" type="Sum" format="N2" footerTemplate={
                  (props: any) => <span>{props.Sum}</span>
                } />
              </AggregateColumnsDirective>
            </AggregateDirective>
          </AggregatesDirective>
          <Inject services={[Page, Filter, Group, ExcelExport, PdfExport, Toolbar, Aggregate, Sort, Resize]} />
        </GridComponent>
      </div>
    </>
  );
}

export default memo(App);